import { ArrowRight } from 'lucide-react';

interface NavigationSuggestionProps {
  /** The route path to navigate to (e.g. "/settings/subscription") */
  path: string;
  /** The display label for the link (e.g. "Subscription Settings") */
  label: string;
  /** Called when the user clicks the link — parent handles actual navigation */
  onNavigate: (path: string) => void;
}

/**
 * Compact inline navigation chip rendered within assistant chat messages.
 *
 * Designed to sit naturally in the flow of text — appears as a clickable
 * pill/link rather than a card, so it doesn't break reading flow.
 */
const NavigationSuggestion = ({ path, label, onNavigate }: NavigationSuggestionProps) => {
  return (
    <button
      type="button"
      onClick={() => onNavigate(path)}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[13px] font-medium transition-all duration-150 hover:gap-1.5 cursor-pointer"
      style={{
        background: 'hsl(214 72% 38% / 0.08)',
        color: 'hsl(214 72% 38%)',
        border: '1px solid hsl(214 72% 38% / 0.15)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'hsl(214 72% 38% / 0.14)';
        e.currentTarget.style.borderColor = 'hsl(214 72% 38% / 0.3)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'hsl(214 72% 38% / 0.08)';
        e.currentTarget.style.borderColor = 'hsl(214 72% 38% / 0.15)';
      }}
      title={`Go to ${label}`}
    >
      <span>{label}</span>
      <ArrowRight className="w-3 h-3 shrink-0" />
    </button>
  );
};

export default NavigationSuggestion;